import React from 'react'

export default function PostList({ content }) {
  const { title, listItems } = content
  return (
    <section className='list-separators'>
      <div className='list-separators__container'>
        <h3 className='list-separators__title'>{title}</h3>
        <ul className='list'>
          {listItems &&
            listItems.map((item, i) => (
              <li
                className='list__item'
                key={i}
                dangerouslySetInnerHTML={{ __html: item.body }}
              />
            ))}
        </ul>
      </div>
    </section>
  )
}
